<template>
    <div>
        <v-dialog max-width="1000px" persistent v-model="showCompanyUsersModal" @close="close">
            <v-card>
                <v-card-title>
                    <span class="headline" style="color: lightgrey">Lista de Funcionário</span>
                    <v-spacer></v-spacer>
                    <span style="font-size: medium; font-weight: bold">{{selectedCompany.name}}</span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-data-table xs12 sm6 md4
                      :headers="headers"
                      :items="users"
                      :search="search"
                      :loading="loading"
                      class="elevation-1"
                      no-data-text="Nenhum Utilizador ainda"
                      no-results-text="nenhum resultado"
                      rows-per-page-text="por página"
                      disable-initial-sort
                    >
                        <v-progress-linear small v-slot:progress color="indigo" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props" >
                            <td class="text-xs-left">{{ props.item.name }}</td>
                            <td class="text-xs-left">{{ props.item.email ? props.item.email : '-------' }}</td>
                            <td class="text-xs-left"><v-chip small outline :color="props.item.access ? 'green' : 'red'">{{ props.item.access ? 'Sim' : 'Não' }}</v-chip></td>
                            <td class="text-xs-right">{{ props.item.created_at | formatDate}}</td>
                            <td class="text-xs-right" style="min-width: 140px; padding-right: 10px;">
                                <v-btn flat small color="primary" @click="showChangePass(props.item)">Alterar senha</v-btn>
                            </td>
                        </template>
                        <template slot="no-data">
                            <v-btn flat color="primary" @click="fetchData()"><v-icon>refresh</v-icon></v-btn>
                            <span class="text-xs-center">nenhum dado encontrado</span>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="close">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <change-password v-if="showChangePasswordModal" @changePasswordCallback="changePassCallback($event)" ></change-password>
    </div>

</template>

<script>
    import Vue from 'vue';
    import ChangePassword from "../user/ChangePassword";
    export default {
        name: "CompanyUsersForm",
        data(){
            return {
                users: [],
                search: '',
                loading: false,
                error_fetching: false,
                headers: [
                    { text: 'Nome', align: 'left', value: 'name' },
                    { text: 'Email', align: 'left', value: 'email'},
                    { text: 'Acesso', align: 'left', value: 'access' },
                    { text: 'Adicionado em', align: 'right', value: 'created_at' },
                    { text: 'Actions', align: 'right', value: '', sortable: false }
                ],

            }
        },

        components: {
            ChangePassword,
        },

        watch: {
            showCompanyUsersModal(){
                if(this.showCompanyUsersModal){
                    console.log('company users form opened');
                    this.fetchData();
                }
            }
        },

        methods: {
            showChangePass(user){
                console.log('showChangePass', user);
                this.showChangePasswordModal = true;
                this.selectedUser = user;
            },

            changePassCallback(payload){
                console.log('changePassCallback', payload);
                this.showSnackBar('Senha alterada com sucesso', 'success');
                if(payload === true){
                    this.showSnackBar('Senha alterada com sucesso', 'success');
                }else{
                    this.showSnackBar('Erro ao a senha do utilizador', 'error');
                }
            },

            fetchData(){
                try{
                    this.users = [];
                    this.loading = true;
                    this.error_fetching = false;

                    Vue.axios.get('/company_users/'+this.selectedCompany.id)
                        .then(response => {
                            // this.consoleLog(response);
                            this.consoleLog(response);
                            if(!response.data.success){
                                this.loading = false;
                                this.error_fetching = true;
                                this.handleErrorCodeMessage(response.data);
                                return;
                            }

                            this.users = response.data.response.users;
                            // }

                            this.loading = false;
                        }).catch(error => {
                        this.consoleLog(error);
                        this.loading = false;
                        this.error_fetching = true;
                        this.showSnackBar('Erro ao carregar lista de utilizadores', 'error');
                    });
                }catch (e) {
                    this.consoleLog(e);
                    this.showSnackBar('Ocorreu um erro ao carregar lista de utilizadores!!', 'error');
                    this.loading_modal = false;
                }
            },

            close() {
                this.showCompanyUsersModal = false;
                this.selectedCompany = null;
            }
        },

        computed: {
            showCompanyUsersModal: {
                get(){
                    return this.$store.getters.getShowCompanyUsersModal;
                },
                set(value){
                    this.$store.dispatch('setShowCompanyUsersModal', value);
                }
            },
            selectedCompany: {
                get(){
                    return this.$store.getters.getSelectedCompany;
                },
                set(value){
                    this.$store.dispatch('setSelectedCompany', value);
                }
            },
            showChangePasswordModal: {
                get(){
                    return this.$store.getters.getShowChangePasswordModal;
                },
                set(value){
                    this.$store.dispatch('setShowChangePasswordModal', value);
                }
            },
            selectedUser: {
                get(){
                    return this.$store.getters.getSelectedUser;
                },
                set(value){
                    this.$store.dispatch('setSelectedUser', value);
                }
            },
        },
    }
</script>

<style scoped>

</style>